module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_yokohama-57e94f634d2e3bd37120b2b20612be51.jpg";